"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSliderInfixComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Icon_1 = __importDefault(require("../../components/Icon/Icon"));
const SliderConstants_1 = require("./SliderConstants");
const SliderContext_1 = require("./SliderContext");
const SelectionIndicator_1 = __importDefault(require("./SelectionIndicator"));
const defaultIconProps = {
    clickable: false,
    iconSize: 18,
    ignoreFocusStyle: true
};
function useSliderInfixComponent(kind) {
    const { prefix, postfix, indicateSelection, selectionIndicatorWidth } = (0, SliderContext_1.useSliderInfix)();
    const { ranged, value, valueText } = (0, SliderContext_1.useSliderSelection)();
    const infix = kind === SliderConstants_1.InfixKind.POSTFIX ? postfix : prefix;
    const isPostfix = kind === SliderConstants_1.InfixKind.POSTFIX;
    if (indicateSelection && (isPostfix || ranged)) {
        return [true, [], (0, jsx_runtime_1.jsx)(SelectionIndicator_1.default, { kind: kind }, kind), { width: selectionIndicatorWidth }];
    }
    if (typeof infix === "object" && infix.icon) {
        const _a = infix, { icon } = _a, restIconProps = __rest(_a, ["icon"]);
        const iconProps = Object.assign(Object.assign({}, defaultIconProps), restIconProps);
        return [true, [], (0, jsx_runtime_1.jsx)(Icon_1.default, Object.assign({ icon: icon }, iconProps), "infix-icon"), {}];
    }
    if (typeof infix === "function") {
        return [true, [], infix(value, valueText), {}];
    }
    if (typeof infix === "string") {
        return [true, ["txt"], (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: infix }), {}];
    }
    if (typeof infix === "undefined") {
        return [false, [], null, {}];
    }
    return [true, [], (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: infix }), {}];
}
exports.useSliderInfixComponent = useSliderInfixComponent;
